// extracted by mini-css-extract-plugin
export default {"container":"rq-z","ratingLayout":"sq-z","ratingLabel":"tq-z","nonInteractiveRatingLabel":"uq-z"};